export const getCookie = (name: string): string => {
  if (typeof window !== "undefined") {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");

    return parts?.pop()?.split(";").shift() || "";
  }
  return "";
};
